export default __webpack_public_path__ + "static/media/custom-writer-on-enterprise-nudge.e3264511.png";